import { useState } from "react";
import { useTranslation } from "react-i18next";
import { faqs } from "@/mocks/faqs";

export default function FAQSection() {
  const { t } = useTranslation("home");
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            {t("faqTitle")}
          </h2>
          <p className="text-sm text-foreground-500">
            {t("faqSubtitle")}
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer group"
              >
                <span className="font-medium text-sm md:text-base text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <span className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openIndex === index
                    ? "bg-primary-500 text-background-50 rotate-45"
                    : "bg-background-200 text-foreground-500 group-hover:bg-background-300"
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "max-h-96" : "max-h-0"
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}